export default "__VITE_ASSET__tBfxjm1Y__"